export const newzealandUniversities = {
  "university-of-auckland": {
    slug: "university-of-auckland", country: "newzealand",
    name: "University of Auckland", shortName: "UoA", flag: "🇳🇿",
    city: "Auckland", founded: 1883, qsRank: "#65 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "New Zealand’s top-ranked university known for engineering, business, medicine, AI, and global research output.",
    tuition: { domestic: "NZ$7,000–$11,000/yr", international: "NZ$32,000–$52,000/yr" },
    living: "NZ$1,400–$2,000/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Data Science", duration: "1.5 years", language: "English" },
      { name: "Master of Engineering", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "NZ$62,000–$110,000", topEmployers: ["PwC", "Deloitte", "Fisher & Paykel", "Spark"] },
    intakes: ["February", "July"], istpStudents: 24,
  },

  "university-of-otago": {
    slug: "university-of-otago", country: "newzealand",
    name: "University of Otago", shortName: "Otago", flag: "🇳🇿",
    city: "Dunedin", founded: 1869, qsRank: "#214 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=900&auto=format&fit=crop",
    overview: "Famous for health sciences, biomedical research, business, and vibrant student culture.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$30,000–$46,000/yr" },
    living: "NZ$1,200–$1,700/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Public Health", duration: "1 year", language: "English" },
      { name: "Master of Business", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "NZ$58,000–$95,000", topEmployers: ["Health NZ", "ANZ", "Deloitte"] },
    intakes: ["February", "July"], istpStudents: 16,
  },

  "university-of-waikato": {
    slug: "university-of-waikato", country: "newzealand",
    name: "University of Waikato", shortName: "Waikato", flag: "🇳🇿",
    city: "Hamilton", founded: 1964, qsRank: "#250 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=900&auto=format&fit=crop",
    overview: "Popular for computer science, management, education, and analytics.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$28,000–$42,000/yr" },
    living: "NZ$1,150–$1,650/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Information Technology", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "NZ$55,000–$90,000", topEmployers: ["Datacom", "Fonterra", "KPMG"] },
    intakes: ["February", "July", "November"], istpStudents: 14,
  },

  "massey-university": {
    slug: "massey-university", country: "newzealand",
    name: "Massey University", shortName: "Massey", flag: "🇳🇿",
    city: "Palmerston North / Auckland", founded: 1927, qsRank: "#239 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?q=80&w=900&auto=format&fit=crop",
    overview: "Strong in aviation, agriculture, business, food technology, and design.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$27,000–$40,000/yr" },
    living: "NZ$1,150–$1,650/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Aviation", duration: "1.5 years", language: "English" },
      { name: "Master of Analytics", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "NZ$54,000–$88,000", topEmployers: ["Air NZ", "Fonterra", "ASB"] },
    intakes: ["February", "July"], istpStudents: 12,
  },

  "victoria-university-of-wellington": {
    slug: "victoria-university-of-wellington", country: "newzealand",
    name: "Victoria University of Wellington", shortName: "VUW", flag: "🇳🇿",
    city: "Wellington", founded: 1897, qsRank: "#241 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1498079022511-d15614cb1c02?q=80&w=900&auto=format&fit=crop",
    overview: "Excellent for public policy, law, computer graphics, data science, and innovation.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$29,000–$43,000/yr" },
    living: "NZ$1,250–$1,750/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Data Science", duration: "1.5 years", language: "English" },
      { name: "Master of Public Policy", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "NZ$56,000–$92,000", topEmployers: ["Govt NZ", "Xero", "Weta Digital"] },
    intakes: ["February", "July"], istpStudents: 13,
  },

  "university-of-canterbury": {
    slug: "university-of-canterbury", country: "newzealand",
    name: "University of Canterbury", shortName: "UC", flag: "🇳🇿",
    city: "Christchurch", founded: 1873, qsRank: "#261 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1562774053-701939374585?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=900&auto=format&fit=crop",

    overview: "Well known for civil engineering, disaster resilience, AI, and product design.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$30,000–$44,000/yr" },
    living: "NZ$1,150–$1,650/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Engineering Studies", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "NZ$55,000–$90,000", topEmployers: ["AECOM", "Beca", "Trimble"] },
    intakes: ["February", "July"], istpStudents: 11,
  },

  "lincoln-university-nz": {
    slug: "lincoln-university-nz", country: "newzealand",
    name: "Lincoln University", shortName: "Lincoln", flag: "🇳🇿",
    city: "Christchurch", founded: 1878, qsRank: "#371 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?q=80&w=900&auto=format&fit=crop",
    overview: "Specialist university in agriculture, environment, tourism, and land management.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$26,000–$38,000/yr" },
    living: "NZ$1,100–$1,550/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Agribusiness", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "NZ$52,000–$84,000", topEmployers: ["Fonterra", "DairyNZ"] },
    intakes: ["February", "July"], istpStudents: 8,
  },

  "auckland-university-of-technology": {
    slug: "auckland-university-of-technology", country: "newzealand",
    name: "Auckland University of Technology", shortName: "AUT", flag: "🇳🇿",
    city: "Auckland", founded: 2000, qsRank: "#407 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Industry-oriented university with strengths in IT, hospitality, business, and health sciences.",
    tuition: { domestic: "NZ$7,000–$10,000/yr", international: "NZ$28,000–$42,000/yr" },
    living: "NZ$1,400–$2,000/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "Master of Computer & Information Sciences", duration: "1.5 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "NZ$54,000–$88,000", topEmployers: ["Spark", "Air NZ", "PwC"] },
    intakes: ["February", "July"], istpStudents: 10,
  },

  "eastern-institute-of-technology": {
    slug: "eastern-institute-of-technology", country: "newzealand",
    name: "Eastern Institute of Technology", shortName: "EIT", flag: "🇳🇿",
    city: "Napier", founded: 1975, qsRank: "#Applied Institute",
    heroImg:
      "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=900&auto=format&fit=crop",

    overview: "Affordable applied education option for IT, business, and healthcare pathways.",
    tuition: { domestic: "NZ$6,000–$9,000/yr", international: "NZ$22,000–$32,000/yr" },
    living: "NZ$1,000–$1,450/mo", ielts: "6.0+", gre: "Not Required",
    topCourses: [
      { name: "Master of Professional Practice", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "NZ$48,000–$75,000", topEmployers: ["Regional Employers"] },
    intakes: ["February", "July"], istpStudents: 6,
  },

  "unitec-institute-of-technology": {
    slug: "unitec-institute-of-technology", country: "newzealand",
    name: "Unitec Institute of Technology", shortName: "Unitec", flag: "🇳🇿",
    city: "Auckland", founded: 1976, qsRank: "#Applied Institute",
    heroImg:
      "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=1600&auto=format&fit=crop",

    campusImg:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=900&auto=format&fit=crop",
    overview: "Career-focused institute known for construction, IT, design, and management.",
    tuition: { domestic: "NZ$6,000–$9,000/yr", international: "NZ$22,000–$34,000/yr" },
    living: "NZ$1,350–$1,950/mo", ielts: "6.0+", gre: "Not Required",
    topCourses: [
      { name: "Master of Applied Technologies", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "NZ$47,000–$72,000", topEmployers: ["Construction Firms", "SMEs"] },
    intakes: ["February", "July"], istpStudents: 5,
  },
};